import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const SearchIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="search" {...props} />;
};

export { SearchIcon };
